import * as React from 'react';

var StickyContainer = function (props) { return (React.createElement("div", { className: (props === null || props === void 0 ? void 0 : props.className) || '', id: props.id }, props.children)); };

export { StickyContainer as default };
//# sourceMappingURL=StickyContainer.js.map
